import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import MyContainerHeader from 'myComponents/MyContainerHeader/index';
import MyFaqResultCard from 'myComponents/MyFaqResultCard/index';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class FaqPage extends React.Component {

    componentDidMount() {
        document.getElementById("searchBox").focus();
    }

    render() {
        return (
            <div className="app-wrapper">
                <MyContainerHeader items={[{title: <IntlMessages id="pages.faq"/>}]} title={<IntlMessages id="pages.faq"/>}/>

                <div className="row">
                    {
                        this.props.faq &&
                        this.props.faq.results.length > 0 &&
                        this.props.faq.results.map((row,i) => 
                        <div key={i} className="col-lg-12 col-sm-12 col-12">
                            <MyFaqResultCard 
                                title={row.title} 
                                text={row.description} 
                                subtitle={row.category + (row.subcategory?(' / ' + row.subcategory):'')}
                                url={row.url}
                            />
                        </div>
                        )
                    }
                </div>

                <div className="d-flex justify-content-center">
                    <h1><IntlMessages id="pages.faq.description"/></h1>
                </div>

            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        faq: state.faq,
    }
}

export default connect(mapStateToProps)(withMobileDialog()(FaqPage));